import { render } from "./FormTitle.vue?vue&type=template&id=3d5eb579"
import script from "./FormTitle.vue?vue&type=script&lang=js"
export * from "./FormTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__